import api from '../services/api';
import { showToast } from './ToastNotification';

/**
 * Akce nad fakturami sdílené výpisem (`InvoiceList`) a detailem (`InvoiceDetail`).
 */

// „1 faktura / 2 faktury / 5 faktur"
export const sklonFaktur = (n) => (n === 1 ? 'faktura' : n >= 2 && n <= 4 ? 'faktury' : 'faktur');
export const sklonFakturu = (n) => (n === 1 ? 'fakturu' : n >= 2 && n <= 4 ? 'faktury' : 'faktur');

// Soubor se stahuje přes dočasný odkaz — fetch potřebujeme kvůli Bearer tokenu,
// prostý <a href> by šel na endpoint bez autorizace.
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/** XML feed pro Money S3 — stáhne soubor a vypíše statistiku. */
export const exportMoneyXml = async (invoiceIds) => {
  const { blob, filename, stats, warnings } = await api.exportInvoicesToMoney(invoiceIds);
  downloadBlob(blob, filename);

  const parts = [`${stats.total} dokladů`];
  if (stats.zalohove) parts.push(`z toho ${stats.zalohove} zálohových`);
  if (stats.chybejici) parts.push(`${stats.chybejici} nenalezeno`);
  showToast(`XML pro Money vygenerováno — ${parts.join(', ')}.`);

  if (warnings.length) {
    console.warn('[Money export] varování:', warnings);
    showToast(`${warnings.length}× upozornění, detail je v konzoli prohlížeče.`, 'warning');
  }
};

/** Výpis faktur do Excelu — jedna faktura i celý výběr jdou stejnou cestou. */
export const exportInvoicesXlsx = async (invoiceIds) => {
  const { blob, filename } = await api.exportInvoicesToXlsx(invoiceIds);
  downloadBlob(blob, filename);
  showToast(`Excel vygenerován — ${invoiceIds.length} ${sklonFaktur(invoiceIds.length)}.`);
};

/** Krátký popisek typu dokladu pro odznaky u položek objednávky. */
export const typDokladu = (type) => ({
  Invoice: 'Faktura',
  Proforma: 'Záloha',
  Confirm: 'Potvrzení',
  Credit: 'Dobropis',
  Debit: 'Vrubopis',
  Cancel: 'Storno',
}[type] || 'Doklad');

/**
 * Plný název dokladu — tak, jak se tiskne na PDF (`InvoicePdfService`).
 *
 * Nadpis v detailu říkal u všeho „Faktura", takže se dobropis od faktury na
 * první pohled nepoznal. Číselník tyhle názvy nemá: „Dobropis" je to, jak mu
 * říká účetní, ale na dokladu i v hlavičce má stát zákonný název.
 */
export const nazevDokladu = (type, typeLabel) => ({
  Invoice: 'Faktura',
  Proforma: 'Zálohová faktura',
  Confirm: 'Potvrzení platby',
  Credit: 'Opravný daňový doklad',
  Debit: 'Vrubopis',
  Cancel: 'Storno',
  Bonus: 'Bonus',
  MultiCorrectionInvoice: 'Hromadný opravný doklad',
}[type] || typeLabel || 'Doklad');
